import ManagerRepository from 'coreClasses/ManagerRepository';
import {IEventData} from 'coreClasses/events/IEvents';
import EventModel from '../EventModel';
import {IEcommerceData} from '../../IGoogleTagManager';

/**
 * Represents PromotionViewEventModel
 */
export default class PromotionViewEventModel extends EventModel {
	public ecommerce: IEcommerceData;

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @param {IEventData} data - data
	 */
	constructor(managerRepository: ManagerRepository, data: IEventData) {
		super(managerRepository, data);

		this.ecommerce = {
			promotionView: {
				promotions: [
					{
						id: data.id,
						name: data.name,
						creative: data.creative,
						position: data.position
					}
				]
			}
		};
	}
};
